// John Eldhose 20190520
import React, { Component } from 'react';
import { Button, CircularProgress, Divider, Grid, IconButton, MenuItem, TextField, Typography } from '@material-ui/core';
import { Add, Done } from '@material-ui/icons';
import { getProducts } from '../../Api/getProducts';
import { loadLoginPage, resetLoginPage } from '../lib/LoginPage';
import ProfileAddress from '../lib/ProfileAddress';
import Checkout from '../lib/Checkout';

class Purchase extends Component {

  state = {
    loaded: false,
    products: {},
    type: '',
    subtype: '',
    price: 0,
    product: '',
    quantity: 1,
    cart: {},
    checkout: [],
    profile: null,
    address: null,
    baddress: null
  }
  productDescription = {};
  productDiscount = {};
  updatePrice = () => {
    let price = this.state.products[this.state.type][this.state.subtype][this.state.product].PRICE;
    if(typeof this.productDiscount[this.state.product] === 'string' && this.productDiscount[this.state.product] !== '') {
      // eslint-disable-next-line
      const temp_func = new Function('qty', this.productDiscount[this.state.product]);
      price -= price * temp_func(this.state.quantity) / 100;
    }
    this.setState({price: ((price < (this.state.products[this.state.type][this.state.subtype][this.state.product].PRICE * .75)) ? this.state.products[this.state.type][this.state.subtype][this.state.product].PRICE : price)});
  }
  componentWillMount() {
    const LoginPage = loadLoginPage();
    if(
      LoginPage !== null && typeof LoginPage.cart !== 'undefined' &&
      Object.keys(LoginPage.cart).length > 0
    ) {
      this.setState({ cart: LoginPage.cart });
      resetLoginPage();
    }
    const search = (window.location.search === '') ?
      '' : decodeURI(window.location.search.substring(1)).split('&');
    getProducts('all')
      .then((prods) => {
        if(prods.status === 'true') {
          const type = (
            typeof search === 'object' && search.length > 0 &&
            typeof prods.data[search[0]] !== 'undefined'
          ) ? search[0] : Object.keys(prods.data)[0];
          const subtype = (
            typeof search === 'object' && search.length > 1 &&
            typeof prods.data[type][search[1]] !== 'undefined'
          ) ? search[1] : Object.keys(prods.data[type])[0];
          let product = Object.keys(prods.data[type][subtype])[0];
          if(typeof search === 'object' && search.length > 2) {
            for(const key in prods.data[type][subtype])
              if(
                typeof prods.data[type][subtype][key]['NAME'] === 'string' &&
                prods.data[type][subtype][key]['NAME'] === search[2]
              )
            product = key;
          }
          let quantity = (
            typeof search === 'object' && search.length > 3 &&
            typeof search[3] !== 'undefined' && parseInt(search[3], 10) > 1
          ) ? parseInt(search[3], 10) : 1;
          this.productDescription = prods.description;
          this.productDiscount = prods.discount;
          this.setState({
            products: prods.data, loaded: true, type: type, subtype: subtype,
            product: product, quantity: quantity
          }, this.updatePrice);
        }
        else
          this.setState({ loaded: true });
      })
      .catch((err) => { console.log(err); })
  }
  showAddToCart = (price) => {
    if(price > 0)
      return (
        <Button
          color='primary'
          variant='raised'
          size='small'
          onClick={this.handleClickAdd}
        >
          <Add /> &nbsp; Add to cart
        </Button>
      );
    else
      return (
        <Typography>
          <a href="http://www.carlsonsw.com/where-to-purchase/dealers/" rel="noopener noreferrer" target="_blank">Contact Sales to Purchase</a>
        </Typography>
      );
  }
  handleChangeSubtype = (subtype) => {
    this.setState({
      subtype: subtype,
      product: Object.keys(this.state.products[this.state.type][subtype])[0]
    }, this.updatePrice);
  }
  handleChangeType = (type) => {
    const subtype = Object.keys(this.state.products[type])[0];
    this.setState({
      type: type, subtype: subtype,
      product: Object.keys(this.state.products[type][subtype])[0]
    }, this.updatePrice);
  }
  handleChangeQuantity = (e) => {
    const qty = parseInt(e.target.value, 10);
    if(typeof qty === 'number' && qty > 0)
      this.setState({ quantity: qty }, this.updatePrice);
  }
  handleClickRemove = (prod) => {
    const cart = this.state.cart;
    delete cart[prod];
    this.setState ({ cart: cart });
  }
  handleClickAdd = () => {
    const cart = this.state.cart;
    if(typeof cart[this.state.product] !== 'undefined')
      this.handleClickRemove(this.state.product);
    cart[this.state.product] = {NAME:  this.state.products[this.state.type][this.state.subtype][this.state.product].NAME, description: this.state.subtype, PRICE: this.state.price, quantity: this.state.quantity };
    this.setState({ cart: cart });
  }
  subtotal = () => {
    var subtotal = 0;
    const cart = Object.keys(this.state.cart);
    for(var i = 0; i < cart.length; i++)
      subtotal += (this.state.cart[cart[i]].PRICE * this.state.cart[cart[i]].quantity);
    return subtotal;
  }
  handleCheckout = () => {
    const checkout = [], keys = Object.keys(this.state.cart);
    for(var i = 0; i < keys.length; i++)
      checkout.push ({
        plan: 'Purchase',
        part: keys[i],
        name: this.state.cart[keys[i]].NAME,
        description: 'Product Type: ' + this.state.cart[keys[i]].description,
        quantity: this.state.cart[keys[i]].quantity,
        price: this.state.cart[keys[i]].PRICE,
        taxCode: 'DC010500'
      });
    this.setState({ checkout: checkout });
  }
  content = () => {
    if(this.state.loaded)
      return  (
        <Grid container>
          <Grid item xs={12} sm={12} md={8} lg={8} xl={8} className='ShoppingCart'>
            <Divider />
            <TextField
              select
              value={this.state.type}
              onChange={(e) => this.handleChangeType(e.target.value)}
              style={{ padding: '5px 0px' }}
            >
              {Object.keys(this.state.products).map((type) => {
                return (
                  <MenuItem key={type} value={type}>
                    <Typography variant='headline'>{type}</Typography>
                  </MenuItem>
                );
              })}
            </TextField>
            <Typography style={{ textAlign: 'justify', padding: '30px' }}>
              {this.productDescription[this.state.type]}
            </Typography>
            <TextField
              select
              value={this.state.subtype}
              onChange={(e) => this.handleChangeSubtype(e.target.value)}
            >
              {Object.keys(this.state.products[this.state.type]).map((type) => {
                return (
                  <MenuItem key={type} value={type}>
                    <Typography variant='title'>{type}</Typography>
                  </MenuItem>
                );
              })}
            </TextField><p />
            <Grid container style={{ margin: '5px 0px', padding: '5px 5px', border: '1px solid silver' }}>
              <Grid item xs={12} sm={12} md={9} lg={9} xl={9} style={{ textAlign: 'left' }}>
                <TextField
                  select
                  value={this.state.product}
                  onChange={(e) => this.setState({ product: e.target.value }, this.updatePrice)}
                  style={{ padding: '5px 0px' }}
                  InputProps={{
                   disableUnderline: true,
                  }}
                >
                  {Object.keys(this.state.products[this.state.type][this.state.subtype]).map((prod) => {
                    return (
                      <MenuItem key={prod} value={prod}>
                        <Typography variant='subheading'>
                          <b>{this.state.products[this.state.type][this.state.subtype][prod].NAME}</b>
                          &nbsp;&nbsp;
                          Unit Price: ${this.state.products[this.state.type][this.state.subtype][prod].PRICE}
                        </Typography>
                      </MenuItem>
                    );
                  })}
                </TextField>
                <Typography>
                  Price: ${this.state.price.toFixed(2)}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3} style={{ textAlign: 'right' }}>
                <TextField
                  fullWidth
                  type='number'
                  label='Quantity'
                  value={this.state.quantity}
                  onChange={this.handleChangeQuantity}
                />
              </Grid>
            </Grid><p />
            <div style={{ padding: '5px 0px', textAlign: 'right' }}>
              {this.showAddToCart(this.state.price)}
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <div className='ShoppingCartTotal'>
              <table width='100%'>
                <tbody>
                  {Object.keys(this.state.cart).map((prod) => {
                    return (
                      <tr key={prod}>
                        <td>
                          <Typography>
                            {this.state.cart[prod].NAME}
                          </Typography>
                          <Typography variant='caption'>
                            Qty: {this.state.cart[prod].quantity}
                          </Typography>
                        </td>
                        <td>
                          <IconButton
                            color='secondary'
                            onClick={() => this.handleClickRemove(prod)}
                            size='small'
                          >
                            <Typography color='secondary'>
                              x
                            </Typography>
                          </IconButton>
                        </td>
                        <td>
                          <Typography style={{ textAlign: 'right' }}>
                            {(this.state.cart[prod].PRICE * this.state.cart[prod].quantity).toLocaleString('en-US', { style: 'currency', currency: 'USD' }
                            )}
                          </Typography>
                        </td>
                      </tr>
                    );
                  })}
                  <tr><td colSpan='3'><Divider /></td></tr>
                  <tr>
                    <td colSpan='2'>
                      <Typography>Subtotal</Typography>
                    </td>
                    <td align='right'>
                      <Typography>
                        {this.subtotal().toLocaleString('en-US', {
                          style: 'currency',
                          currency: 'USD',
                        })}
                      </Typography>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan='3' align='center' style={{ padding: '20px 0px' }}>
                    <Button
                      variant='raised'
                      color='primary'
                      disabled={(Object.keys(this.state.cart).length < 1)}
                      onClick={this.handleCheckout}
                    >
                      <Done /> &nbsp; Checkout
                    </Button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Typography variant='caption'>
                <font size='1' style={{ fontStyle: 'italic' }}>
                  All pricing shown in United States Dollar (USD)
                </font>
              </Typography>
            </div>
          </Grid>
        </Grid>
      );
    else
      return <CircularProgress />;
  }

  render() {
    if(this.state.checkout.length > 0 && this.state.address !== null )
      return (
        <Checkout
          checkout={this.state.checkout}
          profile={this.state.profile}
          address={this.state.address}
          baddress={this.state.baddress}
          completed={() => this.setState({ cart: {} })}
        />
      );
    else if(this.state.checkout.length > 0 && this.state.address === null )
      return (
        <ProfileAddress
          Back={() => this.setState({ checkout: [], address: null })}
          Continue={(p, a, b) => this.setState({ profile: p, address: a, baddress: b })}
        />
      );
    else if(!this.state.loaded)
      return <CircularProgress />;
    else
      return (
        <div>
          <Typography variant='display1'>
            <center><font color='#385687'>Purchase Products</font></center>
          </Typography>
          <p />
          {this.content()}
        </div>
      );
  }
}

export default Purchase;



// WEBPACK FOOTER //
// ./src/components/home/Purchase.js